import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon, StarIcon, SearchIcon, ArrowRightIcon, BookOpenIcon } from 'lucide-react';
import { TroveLayout } from '../../components/Trove/TroveLayout';
import { useDarkMode } from '../../context/DarkModeContext';
import { useUserRole } from '../../context/UserRoleContext';
const genres = [{
  title: 'Romance',
  description: 'Discover the latest trends, tropes, and discussions in the world of romance fiction.',
  icon: HeartIcon,
  to: '/trove/romance',
  color: 'text-pink-500',
  bgColor: 'bg-pink-50',
  darkBgColor: 'bg-pink-900/20',
  borderColor: 'border-pink-200',
  darkBorderColor: 'border-pink-800',
  image: 'https://images.unsplash.com/photo-1516575334481-f85287c2c82d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Fantasy & Sci-Fi',
  description: 'Explore world-building, magic systems, and speculative futures.',
  icon: StarIcon,
  to: '/trove/fantasy-scifi',
  color: 'text-blue-500',
  bgColor: 'bg-blue-50',
  darkBgColor: 'bg-blue-900/20',
  borderColor: 'border-blue-200',
  darkBorderColor: 'border-blue-800',
  image: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Mystery & Thriller',
  description: 'Uncover the art of suspense, plot twists, and keeping readers on the edge of their seats.',
  icon: SearchIcon,
  to: '/trove/mystery-thriller',
  color: 'text-red-500',
  bgColor: 'bg-red-50',
  darkBgColor: 'bg-red-900/20',
  borderColor: 'border-red-200',
  darkBorderColor: 'border-red-800',
  image: 'https://images.unsplash.com/photo-1587876931567-564ce588bfbd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
const TroveGenres = () => {
  const {
    darkMode
  } = useDarkMode();
  const {
    isReader
  } = useUserRole();
  return <TroveLayout data-id="element-17629" data-mp="2rctap3qhjpbn">
      <div className="mb-8" data-id="element-17630" data-mp="2rcbhyh317t8h">
        <div className="flex items-center gap-3 mb-2" data-id="element-17631" data-mp="2gqelgqr26opx">
          <BookOpenIcon className={`h-6 w-6 ${isReader ? 'text-indigo-500' : 'text-purple-500'}`} data-id="element-17632" data-mp="2gov38ulue3li" />
          <h1 className={`text-3xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-17633" data-mp="2lner50jzxpgi">
            Genre Spotlights
          </h1>
        </div>
        <p className={`text-base mb-6 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-17634" data-mp="2cpmczzq0gnup">
          Deep dives into your favorite genres with articles, interviews, and
          resources.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17635" data-mp="34htqira7zk4v">
        {genres.map(genre => <Link key={genre.title} to={genre.to} className={`group block rounded-lg border overflow-hidden transition-all duration-200 hover:shadow-md ${darkMode ? `bg-gray-800 ${genre.darkBorderColor}` : `bg-white ${genre.borderColor}`}`} data-id="element-17636" data-mp="2vnp2sgqduotk">
            <div className="h-48 overflow-hidden" data-id="element-17637" data-mp="3o5t3m8s9b3dg">
              <img src={genre.image} alt={genre.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-17638" data-mp="1cchqj8d9boy" />
            </div>
            <div className="p-6" data-id="element-17639" data-mp="b2fm1fkxuc2l">
              <div className="flex items-center gap-2 mb-3" data-id="element-17640" data-mp="64e1eq7v64p0">
                <genre.icon className={`h-5 w-5 ${genre.color}`} data-id="element-17641" data-mp="64w2c05h1739" />
                <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-17642" data-mp="3ekz0nfap1jex">
                  {genre.title}
                </h2>
              </div>
              <p className={`text-sm mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-17643" data-mp="3oiwpa3wgti82">
                {genre.description}
              </p>
              <div className={`inline-flex items-center text-sm font-medium ${genre.color}`} data-id="element-17644" data-mp="13r39nht5tdjb">
                Explore {genre.title}
                <ArrowRightIcon className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-17645" data-mp="yv5q72mlnr2b" />
              </div>
            </div>
          </Link>)}
      </div>
    </TroveLayout>;
};
export default TroveGenres;